const isStartWithKoOrEn = (str: string) => str.match(/^[ㄱ-ㅎ|가-힣|a-z|A-Z]/);

// 한글이아니거나 영어로 시작하는것이 아니면 후순위로
export const sortByLocaleCompare = (a: string, b: string): number => {
  if (!isStartWithKoOrEn(a)) return 1;
  if (!isStartWithKoOrEn(b)) return -1;
  return a.localeCompare(b);
};
